import { lazy as reactLazy } from 'react';

import { LocalStorage, LocalStorageKeys } from './storage';

// https://gist.github.com/raphael-leger/4d703dea6c845788ff9eb36142374bdb#file-lazywithretry-js
// another option https://medium.com/@botfather/react-loading-chunk-failed-error-88d0bb75b406

// TODO avoid infinite reload

export const lazy = (componentImport: () => Promise<any>): any =>
    reactLazy(async () => {
        const pageHasAlreadyBeenForceRefreshed = Boolean(LocalStorage.get(LocalStorageKeys.LAZY_RELOAD));

        try {
            const component = await componentImport();

            LocalStorage.set(LocalStorageKeys.LAZY_RELOAD, false);

            return component;
        } catch (e) {
            console.error(e);

            if (!pageHasAlreadyBeenForceRefreshed) {
                // Assuming that the user is not on the latest version of the application.
                // Let's refresh the page immediately.
                LocalStorage.set(LocalStorageKeys.LAZY_RELOAD, true);
                window.location.reload();
                // reload() не прерывает текущую цепочку микрозадач: если просто
                // вернуть управление, промис резолвится в undefined и React.lazy
                // падает на `payload.default` ещё до выгрузки страницы
                // (FRONT-5KD: 't.default' в unhandled rejection). Поэтому оставляем
                // компонент в suspense (Suspense-границы есть в app.tsx) — страница
                // успевает перезагрузиться, ошибка не летит.
                return new Promise<never>(() => undefined);
            }

            // The page has already been reloaded
            // Assuming that user is already using the latest version of the application.
            // Let's let the application crash and raise the error.
            throw e;
        }
    });
